import "core-js/stable";
import { LoginRouter } from "@/routers/LoginRouter.tsx";
import { Cvpartner, setCvPartner } from "../Cvpartner.ts";
import "./application_styles.ts";
import "../components/navigation.ts";

// Here be dragons
setCvPartner(new Cvpartner(LoginRouter));
